<template>
    <v-card tile class="pa-0" hover height="100%">
        <v-card-text class="text-center">
            <p v-if="pieOptions.labels.includes('Promoters') || pieOptions.labels.includes('المنتقدون')" class="responsive-p">{{this.series[0]-this.series[2]}}</p>
            <apexchart :height="height" type="donut" :options="pieOptions" :series="pieOptions.series" />
        </v-card-text>
    </v-card>
</template>

<script>
    import apexchart from 'vue-apexcharts'

    export default {

        components: {
            apexchart
        },

        props: ['title', 'height', 'series', 'labels'],

        data() {
            return {
                pieOptions: {
                    series: this.series,
                    colors: ['#004D40', '#71bd48','#01579B', '#006064',  '#00796B', '#0097A7', '#0288D1', '#26A69A', '#26C6DA', '#29B6F6', '#4CAF50', '#66BB6A'],
                    labels: this.labels,
                    title: {
                        text: this.title,
                        align: 'center',
                        margin: 5,
                        offsetX: 0,
                        offsetY: 0,
                        floating: false,
                        style: {
                            fontSize: '11px',
                            fontWeight: '600',
                            fontFamily: undefined,
                            color: '#263238',
                            maxWidth: '200px'
                        }
                    },
                    chart: {
                        type: 'donut',
                        fontFamily: 'Tajawal',
                        toolbar: {
                            show: false,
                        }
                    },
                    xaxis: {
                        axisBorder: {
                            show: false // Remove the bottom border
                        },
                        axisTicks: {
                            show: false // Remove the bottom ticks
                        }
                    },
                    plotOptions: {
                        pie: {
                            donut: {
                                size: '50%'
                            }
                        }
                    },
                    dataLabels: {
                        enabled: true,
                        formatter: function (val, opts) {
                            const percentage = val.toFixed(0) + '%'
                            const number = opts.w.config.series[opts.seriesIndex]
                            return [percentage, number]
                        },
                        style: {
                            fontSize: '9px',
                            fontWeight: ''
                        },
                        offsetX: 0,
                        horizontal: true
                    },
                    responsive: [{
                        breakpoint: 300,
                        options: {
                            chart: {},
                            legend: {
                                show: false
                            }
                        }
                    }],
                    legend: {
                        position: 'bottom',
                    }
                },
                pieSeries: [],
            }
        },
        watch: {
            series: {
                handler(newSeries) {
                    this.$set(this.pieOptions, 'series', newSeries)
                },
                immediate: true
            },
            labels: {
                handler(newLabels) {
                    this.pieOptions = {
                        ...this.pieOptions,
                        labels: newLabels
                    }
                },
                immediate: true
            }
        },
        method: {
            getDataSeries() {
                return this.series
            }
        }
    }
</script>

<style>
    .apexcharts-legend-text {
        padding: 0 5px !important
    }

    .responsive-p {
        position: absolute;
        font-size: 25px;
        color: red;
        font-weight: bold;
        top: calc(50% - 18px);
        right: calc(50% - 14px);
    }

    .apexcharts-toolbar {
        top: -17px !important;
        right: -20px !important;
    }

    @media screen and (max-width: 768px) {
        .responsive-p {
            font-size: 18px;
            top: calc(50% - 40px);
            right: calc(50% - 10px);
        }
    }

    @media screen and (min-width: 768px) and (max-width: 1044px) {
        .responsive-p {
            font-size: 20px;
            top: calc(50% - 37px);
            right: calc(50% - 11px);
        }
    }
</style>